export default __webpack_public_path__ + "images/icons/share/facebook-share-button-dde7083f6f860d2e2396c6a593fbf7e1.svg";